import React from 'react';
import ContactHelper from '../../../helper/ContactHelper';
import ReCAPTCHA from "react-google-recaptcha";
import { Alert } from 'react-bootstrap';

class Contactform extends ContactHelper {
    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="section-header left-side">
                        <div className="section-heading text-left">
                            <h3 className="text-custom-black fw-600">Get In Touch</h3>
                        </div>
                    </div>
                    <form className="contact-form form-style-1" onSubmit={this.handleSubmit.bind(this)}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="text" name="name" value={this.state.name} onChange={this.onNameChange.bind(this)} className="form-control form-control-custom" required />
                                    <label>Full Name <sup className="required">*</sup></label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="email" name="email" value={this.state.email} onChange={this.onEmailChange.bind(this)} className="form-control form-control-custom" required />
                                    <label>Your E-mail <sup className="required">*</sup></label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="text" name="subject" value={this.state.subject} onChange={this.onSubjectChange.bind(this)} className="form-control form-control-custom" required />
                                    <label>Subject <sup className="required">*</sup></label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="number" name="phone" value={this.state.phone} onChange={this.onPhoneChange.bind(this)} className="form-control form-control-custom" required />
                                    <label>Phone No. <sup className="required">*</sup></label>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <textarea rows={5} name="message" value={this.state.message} onChange={this.onMessageChange.bind(this)} className="form-control form-control-custom" required />
                                    <label>Message</label>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <button type="submit" className="btn-submit btn_text_effect"><span className="button_title">Submit</span></button>
                                <ReCAPTCHA
                                    sitekey="6LeazcwcAAAAAFTLy71rIECmWQw3mGHh-G7ELJtF"
                                    onChange={this.reCaptchaLoaded.bind(this)}
                                    size="invisible"
                                />
                            </div>
                            <div className="col-md-12">
                                {/* Form Messages */}
                                <Alert variant="success" className="d-none mt-3 mb-0" id="server_response_success">
                                    <strong>Success!</strong> Contact form has been successfully submitted.
                                </Alert>
                                <Alert variant="danger" className="d-none mt-3 mb-0" id="server_response_danger">
                                    <strong>Oops!</strong> Something bad happened.Please try again later.
                                </Alert>
                                {/* Form Messages */}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default Contactform;